import React, { useEffect, useState, useMemo } from 'react';
import { motion } from 'framer-motion';
import './GreetingOverlay.css';

const GREETINGS = ['Hello', 'Γεια', 'Hola', 'Bonjour'];

export default function GreetingOverlay({ onDone }) {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [finished, setFinished] = useState(false);

  const greetings = useMemo(() => GREETINGS, []);
  const durationMs = 50;
  const holdMs = 40;
  const totalPerGreeting = durationMs * 2 + holdMs;

  useEffect(() => {
    try {
      if (sessionStorage.getItem('greetingSeen') === '1') {
        if (onDone) onDone();
        return;
      }
    } catch (_) {
      /* ignore */
    }
    setVisible(true);
  }, [onDone]);

  useEffect(() => {
    if (!visible || finished) return;

    const timer = setTimeout(() => {
      if (index < greetings.length - 1) {
        setIndex((i) => i + 1);
      } else {
        setFinished(true);
        setTimeout(() => {
          setVisible(false);
          try {
            sessionStorage.setItem('greetingSeen', '1');
          } catch (_) {
            /* ignore */
          }
          if (onDone) onDone();
        }, 400);
      }
    }, totalPerGreeting);

    return () => clearTimeout(timer);
  }, [visible, finished, index, totalPerGreeting, greetings.length, onDone]);

  if (!visible) return null;

  return (
    <motion.div
      className="greeting-overlay"
      initial={{ y: 0 }}
      animate={{ y: finished ? '-100%' : 0 }}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
    >
      <div className="greeting-center">
        <span className="greeting-text">{greetings[index]}</span>
      </div>
    </motion.div>
  );
}
